import { useEffect, useState } from "react";

let deferred: any = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("bhasa-install-ready")); });
}

export function useInstallPrompt() {
  const [ready, setReady] = useState(!!deferred);
  const [installed, setInstalled] = useState(typeof window !== "undefined" && window.matchMedia("(display-mode: standalone)").matches);
  useEffect(() => {
    const onReady = () => setReady(true);
    const onInstalled = () => { setInstalled(true); deferred = null; };
    window.addEventListener("bhasa-install-ready", onReady);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("bhasa-install-ready", onReady); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) && !(window as any).MSStream;
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") { setInstalled(true); deferred = null; }
    return outcome === "accepted";
  };
  return { ready, installed, isIOS, install };
}
